import { useSeo } from "../lib/seo";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import type { AuthSession } from "../types/vtc";
import { AUTH_CONTENT, loginHref, safeNext } from "../data/auth";
import { saveSession } from "../lib/auth";
import { toast } from "../lib/toast";
import AuthLayout, { authLink } from "../components/auth/AuthLayout";
import EmailCodeForm from "../components/auth/EmailCodeForm";
import { FormAlert } from "../components/ui/FormField";
import { useT } from "../i18n";

/** /verify-email?email=…&role=company: an account that signed up but never entered the e-mailed code. */
export default function VerifyEmail() {
  const t = useT();
  useSeo({ title: t.seo.verifyEmail, noindex: true }); // account pages stay out of search results
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") ?? "";
  const role = searchParams.get("role") === "company" ? "company" : "driver";
  const next = safeNext(searchParams.get("next"));

  const onVerified = (session: AuthSession, message: string) => {
    saveSession(session, true);
    toast.success(message);
    navigate(next ?? AUTH_CONTENT[role].dashboardHref);
  };

  return (
    <AuthLayout>
      {email ? (
        <EmailCodeForm role={role} email={email} onVerified={onVerified} />
      ) : (
        <FormAlert>
          {t.auth.driverSignup.missingEmail}{" "}
          <Link to={loginHref(role)} className={authLink}>
            {t.common.login}
          </Link>
        </FormAlert>
      )}
    </AuthLayout>
  );
}
